import PropTypes from "prop-types"
import { connect } from "react-redux"

import {
  deactivateMenu,
  deactivateAccountMenu,
  deactivateSubmenu,
} from "app-store-v2/app/actions"
import { cn } from "styles/utils"

const InternalOverLay = ({ closeMenu, showOverlay }) => (
  <div
    className={cn(
      "bg-black-print/10 fixed inset-0 z-10 hidden",
      showOverlay && "block",
      "desktop:hidden"
    )}
    onClick={() => closeMenu()}
  />
)

InternalOverLay.propTypes = {
  closeMenu: PropTypes.func,
  showOverlay: PropTypes.bool,
}

const mapStateToProps = (state) => {
  const showAccountMenu = state.menu.showAccountMenu
  const showMenu = state.menu.showMenu
  return {
    showOverlay: showAccountMenu || showMenu,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeMenu: () => {
      const pageBody = document.body
      dispatch(deactivateMenu())
      dispatch(deactivateAccountMenu())
      dispatch(deactivateSubmenu())
      pageBody.classList.remove("nav-open")
    },
  }
}

const OverLay = connect(mapStateToProps, mapDispatchToProps)(InternalOverLay)
export default OverLay
